// extracted by mini-css-extract-plugin
module.exports = {"downloadButtonContainer":"auths-table-component_downloadButtonContainer_8ISWw","downloadButton":"auths-table-component_downloadButton_16k8p"};